// 默认主题
import { useMemo } from 'react';
import { theme } from 'antd';

export const defaultThemeToken = {};

export const createDefaultThemeConfig = () => ({
  theme: {
    algorithm: theme.defaultAlgorithm,
    token: defaultThemeToken,
  },
});

const useDefaultTheme = () => {
  return useMemo(() => createDefaultThemeConfig(), []);
};

export default useDefaultTheme;
